export default __webpack_public_path__ + "static/media/Inventory_default.30710eac.svg";